import Logger, { initializeLogger } from './core'

import Config from '@/config'

export default {
  async install(Vue, options = {}) {
    Vue.prototype.$logger = Logger
    initializeLogger(options)
  },
}

if (Config.isDev) {
  window.logger = Logger
}
